<!-- Side Panel Info -->
<div class="sideNavPan" [ngClass]="{'visible': !isClosed }">
  <div class="sideNav-header">
    <h4 class="pageHeader">{{title}}</h4>
    <button type="button" class="close-button" aria-label="Close" (click)="closeSideNavPan()">
      <span class="ion-android-close" area-hidden="true"></span></button>
    </div>
    <div class="sidenav-body">

      <div class="weaveSearch" style="margin: 20px 0;">
        <i class="material-icons searchIcon">search</i>
        <input class="searchField"
               [placeholder]="filterTitle"
               [(ngModel)]="searchQuery"
               (input)="resetPagination(); setCurrentPageItems()"
               name="searchQuery"
               [attr.aria-label]="filterTitle"
        >
      </div>

      <!-- NavSidePanel Table -->
      <div class="oneStandardUnit-content">
        <table class="listingTable">
          <thead>
            <tr>
              <th>{{tableTitle}}</th>
            </tr>
          </thead>
          <tbody>
            @for (item of currentPageItems; track item) {
              <tr>
                <td>
                  @if (item.routerLink) {
                    <a [routerLink]="item.routerLink" [queryParams]="item.queryParams">{{item.name}}</a>
                  }
                  @if (!item.routerLink) {
                    <span>{{item.name}}</span>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <!-- End of NavSidePanel Table -->
      <!-- PAGINATION -->
      @if (pager.totalItems > 0) {
        <app-weave-pagination
          [pager]="pager"
          [isClientSidePagination]="true"
          (updatedPagination)="setPagerOfficial($event)"
          #paginator
        ></app-weave-pagination>
      }
      <!-- END PAGINATION -->
    </div>
    <div class="sidenav-footer">

    </div>
  </div>
